module.exports = __webpack_public_path__ + "img/k5.abd2a37c.jpg";